module.exports = __webpack_public_path__ + "static/media/device.d765b804.svg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/device.svg
// module id = 130
// module chunks = 0